import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';

const openPullRequest = HomePageWidgetBlueprint.make({
  name: 'OpenPullRequest',
  params: {
    name: 'OpenPullRequest',
    description: 'Your open pull requests',
    componentProps: {
      query: 'org:VELUX is:open is:pr author:@me archived:false',
    },
    components: () =>
      import('@roadiehq/backstage-plugin-github-pull-requests').then(m => ({
        Content: m.HomePageYourOpenPullRequestsCard,
      })),
  },
});

const requestedReview = HomePageWidgetBlueprint.make({
  name: 'RequestedReview',
  params: {
    name: 'RequestedReview',
    description: 'Review requests',
    componentProps: {
      query: 'org:VELUX is:open is:pr review-requested:@me archived:false',
    },
    components: () =>
      import('@roadiehq/backstage-plugin-github-pull-requests').then(m => ({
        Content: m.HomePageRequestedReviewsCard,
      })),
  },
});

const announcements = HomePageWidgetBlueprint.make({
  name: 'Announcements',
  params: {
    name: 'Announcements',
    description: 'Announcements',
    components: () =>
      import('@backstage-community/plugin-announcements').then(m => ({
        Content: m.AnnouncementsCard,
      })),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [openPullRequest, requestedReview, announcements],
});
